import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

/** Places disponibles sur un créneau (null = prestation individuelle, pas de compteur affiché). */
export interface SlotCapacity {
  max: number;
  booked: number;
  remaining: number;
  isFull: boolean;
  waitlistCount: number;
}

export interface AvailableSlotDto {
  start: string;
  end: string;
  capacity?: SlotCapacity | null;
}



export const useAvailableSlots = (date: string | null, duration: number, serviceItemId?: string | null) => {
  return useQuery({
    queryKey: [
      "availability-slots",
      date,
      duration,
      serviceItemId ?? undefined,
    ],
    queryFn: async () => {
      const { data } = await api.get("/portal/availability/slots", {
        params: { date, duration, ...(serviceItemId ? { serviceItemId } : {}) },
      });
      return data as AvailableSlotDto[];
    },
    enabled: !!date,
  });
}



/** Rejoint la liste d'attente d'un créneau collectif complet (portail client authentifié). */
export const useJoinWaitlist = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (dto: {
      serviceItemId: string;
      startsAt: string;
      assignedToId?: string;
    }) => {
      const { data } = await api.post("/portal/waitlist", dto);
      return data as { success: boolean; waitlistEntryId: string };
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["availability-slots"] });
      qc.invalidateQueries({ queryKey: ["client-appointments"] });
    },
  });
}



/** Quitte sa propre inscription en liste d'attente. */
export const useLeaveWaitlist = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/portal/waitlist/${id}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["availability-slots"] });
      qc.invalidateQueries({ queryKey: ["client-appointments"] });
    },
  });
}



export const useClosedDates = (from: string | null, to: string | null) => {
  return useQuery({
    queryKey: ["closed-dates", from, to],
    queryFn: async () => {
      const { data } = await api.get("/portal/availability/closed-dates", {
        params: { from, to },
      });
      return data as string[];
    },
    enabled: !!from && !!to,
    staleTime: 1000 * 60 * 5,
  });
}
